import { render } from "./AlunoPendente.vue?vue&type=template&id=3c26f3c0&scoped=true"
import script from "./AlunoPendente.vue?vue&type=script&lang=js"
export * from "./AlunoPendente.vue?vue&type=script&lang=js"

import "./AlunoPendente.vue?vue&type=style&index=0&id=3c26f3c0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c26f3c0"]])

export default __exports__